<template>
  <div>
    <Verge3D :scene="scene"></Verge3D>
    <v-btn
      dark
      absolute
      left
      large
      rounded
      :to="{ name: 'Portfolio' }"
      style="top:50%"
      ><v-icon large dark>
        mdi-arrow-left-circle
      </v-icon></v-btn
    >
  </div>
</template>

<script>
import Verge3D from '@/components/Verge3D.vue'
import catalogueData from '@/data/scenes.json'
export default {
  props: {
    sceneId: {
      required: true
    }
  },
  components: {
    Verge3D
  },
  computed: {
    scene() {
      return catalogueData.find(item => item.id == this.sceneId)
    }
  }
}
</script>

<style lang="scss" scoped></style>
